export const appointment = {
  createAppointment: 'Termin erstellen',
  showClosedAppointments: 'vergangene Termine anzeigen',
  hideClosedAppointments: 'vergangene Termine verbergen',
  appointmentLengthLabel: 'Termindauer:',
  updateModalTitle: 'Termin bearbeiten',
  updateModalButtonText: 'Anpassen',
  deleteModalButtonText: 'Löschen',
  deleteModalTitle: 'Sind Sie sich sicher, dass Sie diesen Termin löschen wollen?',
  reminder: 'Erinnerung',
  reminderInfo: 'Sie werden 24 Stunden vor dem Termin per Mail erinnert.',
  date: 'Datum',
  time: 'Uhrzeit',
  appointment: 'Termin',
  appointmentLength: 'Termindauer (in Minuten)',
  createModalTitle: 'Termin erstellen',
  create: 'Erstellen',
  createErrorToastText: 'Termin konnte nicht erstellt werden.',
  deleteErrorToastText: 'Termin konnte nicht gelöscht werden.',
  updateErrorToastText: 'Termin konne nicht aktualisiert werden.',
  appointments: 'Termine',
  emptyText1: 'Sie haben derzeit noch keine Termine',
  emptyText2: 'Wenn Sie Termine erstellen, werden sie hier dargestellt.',
  emptyText3: 'Alle Termine auf einen Blick!',
  emptyText4: 'Sie können Termine direkt hier erstellen.',
  emptyText5: 'Die Termine, die Sie in Ihrem Projekt erstellen, werden Sie auch hier sehen.',
  buttonText: 'Termin erstellen',
}
